var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "user-home-page dashboard-page" },
    [
      _c("header4IQ", { attrs: { fromapp: "ug", pagename: "tenants" } }),
      _vm._v(" "),
      _vm.showSnackbar
        ? _c("Snackbar", {
            attrs: {
              snackbarColor: _vm.snackbarColor,
              snackbarMessage: _vm.snackbarMessage
            },
            on: {
              close: function($event) {
                return _vm.closeSnackbar()
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("AdvancedSearch", {
        attrs: { enablePopup: _vm.advancedSearchPopUp },
        on: {
          togglepopup: function(val) {
            return (_vm.advancedSearchPopUp = val)
          }
        }
      }),
      _vm._v(" "),
      !_vm.advancedSearchPopUp
        ? _c(
            "main",
            { staticClass: "main-container" },
            [
              _c(
                "section",
                { staticClass: "container-head" },
                [
                  _c(
                    "v-container",
                    { attrs: { fluid: "", "grid-list-lg": "" } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            {
                              staticClass: "tenant_tool_bar",
                              attrs: { xl12: "" }
                            },
                            [
                              _c(
                                "v-toolbar",
                                {
                                  staticStyle: { color: "indigo" },
                                  attrs: {
                                    dense: "",
                                    flat: "",
                                    color: "#EFEFEF"
                                  }
                                },
                                [
                                  _c(
                                    "v-btn-toggle",
                                    {
                                      attrs: { borderless: "", mandatory: "" },
                                      model: {
                                        value: _vm.page,
                                        callback: function($$v) {
                                          _vm.page = $$v
                                        },
                                        expression: "page"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-btn",
                                        { attrs: { value: "tenants" } },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "hidden-sm-and-down"
                                            },
                                            [
                                              _vm._v(
                                                "Tenants ( " +
                                                  _vm._s(
                                                    _vm.getTenantsData.filter(
                                                      function(item) {
                                                        return _vm.enableAdvancedSearch
                                                          ? _vm.getFilteredTenantIds.includes(
                                                              item.pk
                                                            )
                                                          : true
                                                      }
                                                    ).length
                                                  ) +
                                                  " )"
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-spacer"),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticStyle: { display: "flex" } },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            title: "Search",
                                            id: "enableSearch",
                                            color: "#4f2e88"
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.enableSearch = true
                                            }
                                          }
                                        },
                                        [_vm._v("search")]
                                      ),
                                      _vm._v(
                                        "   \n                                 "
                                      ),
                                      _vm.enableSearch
                                        ? _c("v-text-field", {
                                            attrs: {
                                              label: "Search",
                                              id: "closeSearch",
                                              "append-icon": "clear",
                                              autofocus: ""
                                            },
                                            on: {
                                              "click:append":
                                                _vm.resetSearchText
                                            },
                                            model: {
                                              value: _vm.searchText,
                                              callback: function($$v) {
                                                _vm.searchText = $$v
                                              },
                                              expression: "searchText"
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  !_vm.isSuperUser
                                    ? _c(
                                        "span",
                                        { staticStyle: { display: "flex" } },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                title: "Advanced Search",
                                                id: "enableSearch",
                                                color: _vm.enableAdvancedSearch
                                                  ? "#e34d25"
                                                  : "#4f2e88"
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.advancedSearchPopUp = !_vm.advancedSearchPopUp
                                                }
                                              }
                                            },
                                            [_vm._v("zoom_in")]
                                          ),
                                          _vm._v(
                                            "    \n                             "
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticStyle: { display: "flex" } },
                                    [
                                      _c("div", { staticClass: "label-temp" }, [
                                        _vm._v(" Temperature")
                                      ]),
                                      _vm._v(
                                        "   \n                                 "
                                      ),
                                      _c("v-select", {
                                        staticClass: "temperature_select",
                                        attrs: {
                                          id: "temperatureDropdown",
                                          items: _vm.temperatureListDropdown
                                        },
                                        model: {
                                          value: _vm.temperatureSelected,
                                          callback: function($$v) {
                                            _vm.temperatureSelected = $$v
                                          },
                                          expression: "temperatureSelected"
                                        }
                                      }),
                                      _vm._v(
                                        "      \n                             "
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: { cursor: "pointer" },
                                      attrs: { id: "includeDisabledTenants" },
                                      on: {
                                        click: function($event) {
                                          _vm.disableTenants = !_vm.disableTenants
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "#4f2e88" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.disableTenants
                                                ? "check_box"
                                                : "check_box_outline_blank"
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v("Include disabled Tenants")
                                      ]),
                                      _vm._v(" "),
                                      !_vm.disableTenants
                                        ? _c("span", [
                                            _vm._v(
                                              "( " +
                                                _vm._s(
                                                  _vm.filterBy(
                                                    _vm.companies.filter(
                                                      function(item) {
                                                        return _vm.enableAdvancedSearch
                                                          ? _vm.getFilteredTenantIds.includes(
                                                              item.pk
                                                            )
                                                          : true
                                                      }
                                                    ),
                                                    _vm.searchText,
                                                    ["name", "domain"],
                                                    true,
                                                    {
                                                      temperature:
                                                        _vm.temperatureSelected
                                                    }
                                                  ).length -
                                                    _vm.getTenantsData.filter(
                                                      function(item) {
                                                        return _vm.enableAdvancedSearch
                                                          ? _vm.getFilteredTenantIds.includes(
                                                              item.pk
                                                            )
                                                          : true
                                                      }
                                                    ).length
                                                ) +
                                                " )"
                                            )
                                          ])
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _vm._v(
                                    "     \n                             "
                                  ),
                                  _c(
                                    "span",
                                    {
                                      attrs: {
                                        title:
                                          "Download All Tenant's Information"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            color: "#4f2e88",
                                            id: "downloadTenantsInfoBtn"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.downloadTenantsData()
                                            }
                                          }
                                        },
                                        [_vm._v("get_app")]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(
                                    "                     \n                             "
                                  ),
                                  !_vm.isSuperUser
                                    ? _c(
                                        "span",
                                        { attrs: { title: "Create Tenant" } },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              staticStyle: { color: "#4f2e88" },
                                              attrs: {
                                                id: "tenantCreationBtn"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.newTenantPopUp()
                                                }
                                              }
                                            },
                                            [_vm._v("add")]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "section",
                [
                  _c(
                    "v-container",
                    { attrs: { fluid: "", "grid-list-lg": "" } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        _vm._l(
                          _vm.getTenantsData.filter(function(item) {
                            return _vm.enableAdvancedSearch
                              ? _vm.getFilteredTenantIds.includes(item.pk)
                              : true
                          }),
                          function(cmpny, index) {
                            return _c(
                              "v-flex",
                              { key: cmpny.title, attrs: { lg3: "" } },
                              [
                                _c(
                                  "v-card",
                                  { attrs: { id: "tenantsCard" } },
                                  [
                                    _c(
                                      "v-layout",
                                      {
                                        staticClass: "tenants-card",
                                        class: cmpny.disabled ? "disabled" : ""
                                      },
                                      [
                                        _c(
                                          "v-flex",
                                          {
                                            staticClass: "company-logo",
                                            attrs: {
                                              xs5: "",
                                              "overflow-hidden": ""
                                            }
                                          },
                                          [
                                            cmpny.logo != null
                                              ? _c("span", [
                                                  _c("img", {
                                                    staticClass: "logo-img",
                                                    attrs: { src: cmpny.logo }
                                                  })
                                                ])
                                              : _c("span", [
                                                  _c("img", {
                                                    staticClass: "logo-img",
                                                    attrs: {
                                                      src: require("../../../common/assets/images/default_tenant_image.png")
                                                    }
                                                  })
                                                ])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          {
                                            staticClass: "company-info",
                                            attrs: {
                                              xs7: "",
                                              "overflow-hidden": ""
                                            }
                                          },
                                          [
                                            _c(
                                              "v-layout",
                                              [
                                                _c(
                                                  "v-flex",
                                                  { attrs: { xs12: "" } },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "company-name"
                                                      },
                                                      [
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(cmpny.domain)
                                                          )
                                                        ])
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "company-username"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            cmpny.sales_rep ||
                                                              "4iqSales"
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      { staticClass: "a-text" },
                                                      [
                                                        _c(
                                                          "a",
                                                          {
                                                            attrs: {
                                                              target: "new"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                cmpny.website ||
                                                                  ""
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-layout",
                                              {
                                                staticClass: "card-bottom",
                                                attrs: { row: "", wrap: "" }
                                              },
                                              [
                                                _c(
                                                  "v-flex",
                                                  { attrs: { xs6: "" } },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.switchTenant(
                                                              cmpny,
                                                              "apps"
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [_vm._v("vpn_key")]
                                                    ),
                                                    _vm._v(" "),
                                                    !_vm.enableAdvancedSearch
                                                      ? _c(
                                                          "span",
                                                          {
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.switchTenant(
                                                                  cmpny,
                                                                  "apps"
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                cmpny.num_apps ||
                                                                  0
                                                              ) + " Tokens"
                                                            )
                                                          ]
                                                        )
                                                      : _c(
                                                          "span",
                                                          {
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.switchTenant(
                                                                  cmpny,
                                                                  "apps"
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm
                                                                  .tenantSeperatedDetails[
                                                                  cmpny[
                                                                    "schema_name"
                                                                  ]
                                                                ].app_id
                                                                  .length || 0
                                                              ) + " Tokens"
                                                            )
                                                          ]
                                                        )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-flex",
                                                  { attrs: { xs6: "" } },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.switchTenant(
                                                              cmpny,
                                                              "users"
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [_vm._v("group")]
                                                    ),
                                                    _vm._v(" "),
                                                    !_vm.enableAdvancedSearch
                                                      ? _c(
                                                          "span",
                                                          {
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.switchTenant(
                                                                  cmpny,
                                                                  "users"
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                cmpny.num_users ||
                                                                  0
                                                              ) + " Users"
                                                            )
                                                          ]
                                                        )
                                                      : _c(
                                                          "span",
                                                          {
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.switchTenant(
                                                                  cmpny,
                                                                  "users"
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm
                                                                  .tenantSeperatedDetails[
                                                                  cmpny[
                                                                    "schema_name"
                                                                  ]
                                                                ].user_id
                                                                  .length || 0
                                                              ) + " Users"
                                                            )
                                                          ]
                                                        )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("v-divider", {
                                      staticClass: "temperature lighten-3",
                                      class: cmpny.temperature || "green"
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "v-card-actions",
                                      [
                                        _c("h3", {
                                          domProps: {
                                            textContent: _vm._s(cmpny.name)
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("v-spacer"),
                                        _vm._v(" "),
                                        _c(
                                          "v-menu",
                                          {
                                            attrs: {
                                              transition: "scale-transition",
                                              "close-on-content-click":
                                                _vm.closeMenu,
                                              "offset-x": "",
                                              right: ""
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function(ref) {
                                                    var on = ref.on
                                                    return [
                                                      !_vm.isSuperUser
                                                        ? _c(
                                                            "v-btn",
                                                            _vm._g(
                                                              {
                                                                attrs: {
                                                                  slot:
                                                                    "activator",
                                                                  icon: "",
                                                                  color: "grey",
                                                                  id:
                                                                    "openMenuBtn"
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.openMenu(
                                                                      cmpny,
                                                                      index
                                                                    )
                                                                  }
                                                                },
                                                                slot:
                                                                  "activator"
                                                              },
                                                              on
                                                            ),
                                                            [
                                                              _c("v-icon", [
                                                                _vm._v(
                                                                  "more_vert"
                                                                )
                                                              ])
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              true
                                            )
                                          },
                                          [
                                            _vm._v(" "),
                                            _c(
                                              "v-list",
                                              { staticClass: "tenants-list" },
                                              [
                                                _c(
                                                  "v-list-item",
                                                  {
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.switchTenant(
                                                          cmpny,
                                                          "users"
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("v-list-item-title", [
                                                      _vm._v("Users")
                                                    ])
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-list-item",
                                                  {
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.switchTenant(
                                                          cmpny,
                                                          "apps"
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("v-list-item-title", [
                                                      _vm._v("Tokens/Apps")
                                                    ])
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-list-item",
                                                  {
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.editTenant(
                                                          cmpny
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("v-list-item-title", [
                                                      _vm._v("Edit")
                                                    ])
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-list-item",
                                                  {
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.SSOConfigurationPopup(
                                                          cmpny
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("v-list-item-title", [
                                                      _vm._v(
                                                        "SSO Configuration"
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-list-item",
                                                  {
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.changeThumbnailPopup(
                                                          cmpny
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("v-list-item-title", [
                                                      _vm._v("Change Logo")
                                                    ])
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-list-item",
                                                  {
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.showNotesPopup(
                                                          cmpny
                                                        )
                                                      },
                                                      mouseover: function(
                                                        $event
                                                      ) {
                                                        _vm.closeMenu = true
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("v-list-item-title", [
                                                      _vm._v("Notes")
                                                    ])
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c("v-divider"),
                                                _vm._v(" "),
                                                _c(
                                                  "v-list-item",
                                                  {
                                                    class: cmpny["2fa_enabled"]
                                                      ? "enabled"
                                                      : "disabled-2fa",
                                                    attrs: {
                                                      title: cmpny[
                                                        "2fa_enabled"
                                                      ]
                                                        ? "Click to Disable 2FA"
                                                        : "Click to Enable 2FA"
                                                    },
                                                    on: {
                                                      mouseover: function(
                                                        $event
                                                      ) {
                                                        _vm.closeMenu = false
                                                      },
                                                      click: function($event) {
                                                        return _vm.reset2FA(
                                                          cmpny
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    cmpny["2fa_enabled"]
                                                      ? _c(
                                                          "v-icon",
                                                          {
                                                            staticClass:
                                                              "done_icon mr-4"
                                                          },
                                                          [_vm._v("done")]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-list-item-title",
                                                      {
                                                        staticClass:
                                                          "authSpacing",
                                                        class: cmpny[
                                                          "2fa_enabled"
                                                        ]
                                                          ? "menucontentleftpadding"
                                                          : "adisabled"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "2-Factor Authentication"
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                cmpny.disabled
                                                  ? _c(
                                                      "v-list-item",
                                                      {
                                                        class: !cmpny.disabled
                                                          ? "valid"
                                                          : "invalid",
                                                        on: {
                                                          mouseover: function(
                                                            $event
                                                          ) {
                                                            _vm.closeMenu = false
                                                          },
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.disableTenant(
                                                              cmpny,
                                                              "enable"
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "v-list-item-title",
                                                          [
                                                            _vm._v(
                                                              "Enable company"
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _c(
                                                      "v-list-item",
                                                      {
                                                        class: cmpny.disabled
                                                          ? "valid"
                                                          : "invalid",
                                                        on: {
                                                          mouseover: function(
                                                            $event
                                                          ) {
                                                            _vm.closeMenu = true
                                                          },
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.disableTenant(
                                                              cmpny,
                                                              "disable"
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "v-list-item-title",
                                                          [
                                                            _vm._v(
                                                              "Disable company"
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-list-item",
                                                  [
                                                    _c("v-list-item-title", [
                                                      _vm._v("Temperature")
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-menu",
                                                      {
                                                        attrs: {
                                                          "offset-x": "",
                                                          "nudge-right": 18
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "activator",
                                                              fn: function(
                                                                ref
                                                              ) {
                                                                var on = ref.on
                                                                return [
                                                                  _c(
                                                                    "v-btn",
                                                                    _vm._g(
                                                                      {
                                                                        staticClass:
                                                                          "gray light",
                                                                        attrs: {
                                                                          slot:
                                                                            "activator",
                                                                          icon:
                                                                            "",
                                                                          color:
                                                                            "grey"
                                                                        },
                                                                        on: {
                                                                          mouseover: function(
                                                                            $event
                                                                          ) {
                                                                            _vm.closeMenu = false
                                                                          }
                                                                        },
                                                                        slot:
                                                                          "activator"
                                                                      },
                                                                      on
                                                                    ),
                                                                    [
                                                                      _c(
                                                                        "v-icon",
                                                                        [
                                                                          _vm._v(
                                                                            "keyboard_arrow_right"
                                                                          )
                                                                        ]
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ]
                                                              }
                                                            }
                                                          ],
                                                          null,
                                                          true
                                                        )
                                                      },
                                                      [
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-list",
                                                          {
                                                            staticClass:
                                                              "temparature_menu"
                                                          },
                                                          _vm._l(
                                                            _vm.temperatureList,
                                                            function(color) {
                                                              return _c(
                                                                "v-list-item",
                                                                {
                                                                  key: color,
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.changeTemperature(
                                                                        cmpny,
                                                                        color
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  cmpny.temperature ==
                                                                  color
                                                                    ? _c(
                                                                        "v-icon",
                                                                        {
                                                                          staticClass:
                                                                            "done_icon mr-4"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "done"
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  _vm._v(
                                                                    " \n                                                         "
                                                                  ),
                                                                  _c(
                                                                    "v-list-item-title",
                                                                    {
                                                                      staticClass:
                                                                        "tmpColor",
                                                                      class:
                                                                        cmpny.temperature ==
                                                                        color
                                                                          ? "menucontentleftpadding"
                                                                          : "tdisabled"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          color
                                                                        )
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            }
                                                          ),
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c("v-divider"),
                                                _vm._v(" "),
                                                _c(
                                                  "v-list-item",
                                                  [
                                                    _c(
                                                      "v-list-item-title",
                                                      {
                                                        class: cmpny.ticket_link
                                                          ? ""
                                                          : "disabled"
                                                      },
                                                      [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "cmpny_links",
                                                            attrs: {
                                                              target: "new",
                                                              href:
                                                                cmpny.ticket_link
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Support Tickets"
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-list-item",
                                                  [
                                                    _c(
                                                      "v-list-item-title",
                                                      {
                                                        class: cmpny.confluence
                                                          ? ""
                                                          : "disabled"
                                                      },
                                                      [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "cmpny_links",
                                                            attrs: {
                                                              target: "new",
                                                              href:
                                                                cmpny.confluence
                                                            }
                                                          },
                                                          [_vm._v("Confluence")]
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-list-item",
                                                  [
                                                    _c(
                                                      "v-list-item-title",
                                                      {
                                                        class: cmpny.drive_location
                                                          ? ""
                                                          : "disabled"
                                                      },
                                                      [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "cmpny_links",
                                                            attrs: {
                                                              target: "new",
                                                              href:
                                                                cmpny.drive_location
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Google Drive Folder"
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c("v-divider"),
                                                _vm._v(" "),
                                                _c(
                                                  "v-list-item",
                                                  {
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.showMergeTenantPopup(
                                                          cmpny
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("v-list-item-title", [
                                                      _vm._v("Merge")
                                                    ])
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-list-item",
                                                  {
                                                    class: !cmpny.num_apps
                                                      ? ""
                                                      : "disabled",
                                                    on: {
                                                      click: function($event) {
                                                        _vm.deleteTenantPopUp = true
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("v-list-item-title", [
                                                      _vm._v("Delete")
                                                    ])
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          }
                        ),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "section",
                [
                  _c(
                    "v-dialog",
                    {
                      attrs: { persistent: "", "max-width": "600px" },
                      model: {
                        value: _vm.mergeDialog,
                        callback: function($$v) {
                          _vm.mergeDialog = $$v
                        },
                        expression: "mergeDialog"
                      }
                    },
                    [
                      _c("v-card", { attrs: { id: "mergeTenantsDialog" } }, [
                        _c(
                          "div",
                          { staticClass: "user_creation_popup_div" },
                          [
                            _c(
                              "v-layout",
                              { attrs: { row: "", wrap: "" } },
                              [
                                _c(
                                  "v-flex",
                                  { attrs: { xs12: "" } },
                                  [
                                    _c("v-card-title", [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "headline indigo--text"
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { medium: "" } },
                                            [_vm._v("merge_type")]
                                          ),
                                          _vm._v(
                                            " Merge with Another Company\n                                     "
                                          )
                                        ],
                                        1
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-layout",
                              { attrs: { row: "", wrap: "" } },
                              [
                                _c(
                                  "v-card-text",
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { xs12: "" } },
                                      [
                                        _c("v-select", {
                                          attrs: {
                                            id: "mergeTenantsDropdown",
                                            items: _vm.companies,
                                            label: "Company",
                                            "item-text": "name",
                                            "item-disabled": "customDisabled",
                                            outline: ""
                                          },
                                          model: {
                                            value: _vm.selectedTenantForMerge,
                                            callback: function($$v) {
                                              _vm.selectedTenantForMerge = $$v
                                            },
                                            expression: "selectedTenantForMerge"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.selectedTenantForMerge &&
                                    _vm.mergeDialog
                                      ? _c("span", [
                                          _vm._v(
                                            "* " +
                                              _vm._s(
                                                _vm.selectedTenantForMerge
                                              ) +
                                              " will be removed and all apps transferred to " +
                                              _vm._s(_vm.tenantInfo["name"])
                                          )
                                        ])
                                      : _vm._e(),
                                    _c("br"),
                                    _c("br"),
                                    _vm._v(" "),
                                    _vm.selectedTenantForMerge &&
                                    _vm.mergeDialog
                                      ? _c(
                                          "v-flex",
                                          { attrs: { xs12: "" } },
                                          [
                                            _c("v-icon", {
                                              staticClass: "pa-0 ma-0",
                                              domProps: {
                                                textContent: _vm._s(
                                                  _vm.migrateUsers
                                                    ? "check_box"
                                                    : "check_box_outline_blank"
                                                )
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.migrateUsers = !_vm.migrateUsers
                                                }
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                "Migrate the users( " +
                                                  _vm._s(
                                                    _vm.companies[
                                                      _vm.companies.findIndex(
                                                        function(x) {
                                                          return (
                                                            x.name ===
                                                            _vm.selectedTenantForMerge
                                                          )
                                                        }
                                                      )
                                                    ]["num_users"]
                                                  ) +
                                                  " ) from " +
                                                  _vm._s(
                                                    _vm.selectedTenantForMerge
                                                  ) +
                                                  " to " +
                                                  _vm._s(_vm.tenantInfo["name"])
                                              )
                                            ])
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-layout",
                              [
                                _c(
                                  "v-flex",
                                  {
                                    staticClass: "save_in_merge",
                                    attrs: { xs12: "" }
                                  },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          depressed: "",
                                          color: "grey lighten-3"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.resetData()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                     cancel\n                                 "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-btn",
                                      {
                                        class:
                                          _vm.selectedTenantForMerge &&
                                          !_vm.disableActionBtn
                                            ? ""
                                            : "disabled",
                                        attrs: {
                                          tabindex: _vm.selectedTenantForMerge
                                            ? ""
                                            : -1,
                                          depressed: "",
                                          color: "grey lighten-3"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.mergeTenats()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                     Merge\n                                 "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "section",
                [
                  _c(
                    "v-dialog",
                    {
                      attrs: { "max-width": "600px", persistent: "" },
                      model: {
                        value: _vm.changeThumbnail,
                        callback: function($$v) {
                          _vm.changeThumbnail = $$v
                        },
                        expression: "changeThumbnail"
                      }
                    },
                    [
                      _c("v-card", { attrs: { id: "changeLogoCard" } }, [
                        _c(
                          "div",
                          { staticClass: "user_creation_popup_div" },
                          [
                            _c(
                              "v-layout",
                              { attrs: { row: "", wrap: "" } },
                              [
                                _c(
                                  "v-flex",
                                  { attrs: { xs12: "" } },
                                  [
                                    _c("v-card-title", [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "headline indigo--text"
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { medium: "" } },
                                            [_vm._v("info_outline")]
                                          ),
                                          _vm._v(
                                            " Change Logo\n                                     "
                                          )
                                        ],
                                        1
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-layout",
                              { attrs: { row: "", wrap: "" } },
                              [
                                _c(
                                  "v-flex",
                                  { staticClass: "pl-3", attrs: { xs12: "" } },
                                  [
                                    _c("div", { staticClass: "company-logo" }, [
                                      _c("img", {
                                        staticClass: "logo-img",
                                        attrs: {
                                          src: _vm.thumbnailCompany
                                            ? _vm.thumbnailCompany["logo"]
                                            : "#",
                                          id: "profile-img-tag",
                                          title: "Add Logo"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("input", {
                                        staticStyle: { display: "none" },
                                        attrs: {
                                          type: "file",
                                          id: "new_logo",
                                          name: "newCompanyLogo",
                                          onclick: "this.value = null;"
                                        },
                                        on: { change: _vm.readURL }
                                      })
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  { staticClass: "pl-3" },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "change_logo",
                                        on: {
                                          click: function($event) {
                                            return _vm.changeThumbnailPopup()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                     Update\n                                 "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-layout",
                              [
                                _c(
                                  "v-flex",
                                  {
                                    staticClass: "save_in_merge",
                                    attrs: { xs12: "" }
                                  },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        class: _vm.disableActionBtn
                                          ? "disabled"
                                          : "",
                                        attrs: {
                                          depressed: "",
                                          color: "grey lighten-3"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.save_thumbnail_logo()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                     Save\n                                 "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          depressed: "",
                                          color: "grey lighten-3"
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.changeThumbnail = false
                                            _vm.logoElement = {}
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                     Cancel\n                                 "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "section",
                [
                  _c(
                    "v-dialog",
                    {
                      staticClass: "show-info-popup",
                      attrs: { width: "60rem", persistent: "" },
                      model: {
                        value: _vm.showSSOConfigurationPopup,
                        callback: function($$v) {
                          _vm.showSSOConfigurationPopup = $$v
                        },
                        expression: "showSSOConfigurationPopup"
                      }
                    },
                    [
                      _c("v-card", { staticClass: "popup-card" }, [
                        _c("div", { staticClass: "user_creation_popup_div" }, [
                          _c(
                            "div",
                            [
                              _c(
                                "v-form",
                                { ref: "form" },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "", wrap: "" } },
                                    [
                                      _c(
                                        "v-flex",
                                        {
                                          staticClass: "pa-2 ma-2",
                                          attrs: { xs1: "" }
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              staticClass: "apps_creation_logo"
                                            },
                                            [
                                              _vm._v(
                                                "\n                                                 business\n                                             "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.editableSSOConfiguration < 0
                                        ? _c(
                                            "v-flex",
                                            {
                                              staticClass:
                                                "pa-2 ma-2 mt-4 pt-3",
                                              attrs: { xs10: "" }
                                            },
                                            [
                                              _c("h3", [
                                                _vm._v("Edit SSO Configuration")
                                              ]),
                                              _vm._v(" "),
                                              !_vm.showAdditionalFields
                                                ? _c("h5", [
                                                    _vm._v(
                                                      "All fields required *"
                                                    )
                                                  ])
                                                : _vm._e()
                                            ]
                                          )
                                        : _c(
                                            "v-flex",
                                            {
                                              staticClass:
                                                "pa-2 ma-2 mt-4 pt-3",
                                              attrs: { xs10: "" }
                                            },
                                            [
                                              _c("h3", [
                                                _vm._v("SSO Configuration")
                                              ]),
                                              _vm._v(" "),
                                              !_vm.showAdditionalFields
                                                ? _c("h5", [
                                                    _vm._v(
                                                      "All fields required *"
                                                    )
                                                  ])
                                                : _vm._e()
                                            ]
                                          )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  !_vm.showAdditionalFields
                                    ? _c(
                                        "div",
                                        [
                                          _c(
                                            "v-layout",
                                            { attrs: { row: "", wrap: "" } },
                                            [
                                              _c(
                                                "v-flex",
                                                {
                                                  staticClass: "pa-2 ma-2 pt-4",
                                                  attrs: { xs3: "" }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                             SSO Configuration\n                                         "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-flex",
                                                {
                                                  staticClass: "pb-2",
                                                  attrs: { xs8: "" }
                                                },
                                                [
                                                  _c(
                                                    "v-radio-group",
                                                    {
                                                      attrs: { row: "" },
                                                      model: {
                                                        value:
                                                          _vm.ssoConfigStatus,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.ssoConfigStatus = $$v
                                                        },
                                                        expression:
                                                          "ssoConfigStatus"
                                                      }
                                                    },
                                                    [
                                                      _c("v-radio", {
                                                        attrs: {
                                                          label: "Enable",
                                                          value: "enable"
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("v-radio", {
                                                        attrs: {
                                                          label: "Disable",
                                                          value: "disable"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-layout",
                                            { attrs: { row: "", wrap: "" } },
                                            [
                                              _c(
                                                "v-flex",
                                                {
                                                  staticClass: "pa-2 ma-2 pt-4",
                                                  attrs: { xs3: "" }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                             Identity Provider\n                                         "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-flex",
                                                {
                                                  staticClass: "pb-2",
                                                  attrs: { xs8: "" }
                                                },
                                                [
                                                  _c(
                                                    "v-radio-group",
                                                    {
                                                      class:
                                                        _vm.ssoConfigStatus ==
                                                        "disable"
                                                          ? "disabled"
                                                          : "",
                                                      attrs: { row: "" },
                                                      model: {
                                                        value:
                                                          _vm.selectedIdentityProvider,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.selectedIdentityProvider = $$v
                                                        },
                                                        expression:
                                                          "selectedIdentityProvider"
                                                      }
                                                    },
                                                    _vm._l(
                                                      _vm.identityProviderLabels,
                                                      function(idp, index) {
                                                        return _c("v-radio", {
                                                          key: index,
                                                          attrs: {
                                                            label: idp.label,
                                                            value: idp.value
                                                          }
                                                        })
                                                      }
                                                    ),
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("idpSSOConfigFormVue", {
                                            ref: "idpSSOConfigFormRef",
                                            attrs: {
                                              ssoConfig: _vm.sso_configuration,
                                              identityProvider:
                                                _vm.selectedIdentityProvider,
                                              enableConfigForm:
                                                _vm.ssoConfigStatus == "disable"
                                                  ? "disabled"
                                                  : ""
                                            },
                                            on: {
                                              idpSSOConfigFormData:
                                                _vm.getIdpSSOConfigFormData
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "v-layout",
                                            { attrs: { row: "", wrap: "" } },
                                            [
                                              _c(
                                                "v-flex",
                                                {
                                                  staticClass: "pa-2 ma-2 pt-4",
                                                  attrs: { xs3: "" }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                             " +
                                                      _vm._s(
                                                        _vm.idpCertificateLabel[
                                                          _vm
                                                            .selectedIdentityProvider
                                                        ] || "Certificate"
                                                      ) +
                                                      "\n                                         "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-layout",
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      staticClass: "mt-4",
                                                      class:
                                                        _vm.ssoConfigStatus ==
                                                        "disable"
                                                          ? "disabled"
                                                          : "",
                                                      attrs: {
                                                        depressed: "",
                                                        color: "#4f2e88",
                                                        dark: "",
                                                        small: ""
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.uploadCertificateFile()
                                                        }
                                                      }
                                                    },
                                                    [_vm._v("Upload file")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("input", {
                                                    staticStyle: {
                                                      display: "none"
                                                    },
                                                    attrs: {
                                                      type: "file",
                                                      id: "samlCertificate",
                                                      "prepend-icon": ""
                                                    },
                                                    on: {
                                                      change:
                                                        _vm.verifySSOCertFile
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: { top: "" },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function(ref) {
                                                              var on = ref.on
                                                              var attrs =
                                                                ref.attrs
                                                              return [
                                                                _c(
                                                                  "h4",
                                                                  _vm._g(
                                                                    _vm._b(
                                                                      {
                                                                        staticClass:
                                                                          "certificatefileclass"
                                                                      },
                                                                      "h4",
                                                                      attrs,
                                                                      false
                                                                    ),
                                                                    on
                                                                  ),
                                                                  [
                                                                    _vm._v(
                                                                      "File name : " +
                                                                        _vm._s(
                                                                          _vm.modify_file_name(
                                                                            _vm
                                                                              .certificate_file
                                                                              .name
                                                                          ) ||
                                                                            _vm.modify_file_name(
                                                                              _vm
                                                                                .sso_configuration
                                                                                .file_name
                                                                            ) ||
                                                                            "-"
                                                                        )
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        false,
                                                        943855915
                                                      )
                                                    },
                                                    [
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.certificate_file
                                                              .name ||
                                                              _vm
                                                                .sso_configuration
                                                                .file_name ||
                                                              "Upload a file to see file name"
                                                          )
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-layout",
                                            { attrs: { row: "", wrap: "" } },
                                            [
                                              _c(
                                                "v-flex",
                                                {
                                                  staticClass: "pa-2 ma-2 pt-5",
                                                  attrs: { xs3: "" }
                                                },
                                                [
                                                  _c(
                                                    "p",
                                                    {
                                                      attrs: {
                                                        title:
                                                          "Synchronize actions with Identity provider"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Synchronize configuration"
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-flex",
                                                {
                                                  staticClass: "pa-2",
                                                  attrs: { xs4: "" }
                                                },
                                                [
                                                  _c("v-checkbox", {
                                                    attrs: {
                                                      title:
                                                        "Delete user when deleted in Identity provider",
                                                      color: "#4f2e88",
                                                      label:
                                                        "Synchronize user deletion"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.sso_configuration
                                                          .sync_deletion,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.sso_configuration,
                                                          "sync_deletion",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "sso_configuration.sync_deletion"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _c(
                                        "div",
                                        [
                                          _c("idpSSOConfigFormVue", {
                                            ref: "idpSSOConfigFormRef",
                                            staticClass: "hideIdpConfiguration",
                                            attrs: {
                                              ssoConfig: _vm.sso_configuration,
                                              identityProvider:
                                                _vm.selectedIdentityProvider,
                                              enableConfigForm:
                                                _vm.ssoConfigStatus == "disable"
                                                  ? "disabled"
                                                  : ""
                                            },
                                            on: {
                                              idpSSOConfigFormData:
                                                _vm.getIdpSSOConfigFormData
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "v-layout",
                                            { attrs: { row: "", wrap: "" } },
                                            [
                                              _c(
                                                "v-flex",
                                                {
                                                  staticClass: "pa-2 ma-2 pt-4",
                                                  attrs: { xs3: "" }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                             Advanced settings\n                                         "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-flex",
                                                {
                                                  staticClass: "pa-2",
                                                  attrs: { xs8: "" }
                                                },
                                                [
                                                  _c("textarea", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.sso_configuration
                                                            .additional_fields_string,
                                                        expression:
                                                          "sso_configuration.additional_fields_string"
                                                      }
                                                    ],
                                                    staticClass: "text_area",
                                                    class:
                                                      _vm.ssoConfigStatus ==
                                                      "disable"
                                                        ? "disabled"
                                                        : "",
                                                    attrs: {
                                                      id: "configurationInfo"
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.sso_configuration
                                                          .additional_fields_string
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.sso_configuration,
                                                          "additional_fields_string",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  })
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                  _vm._v(" "),
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "", wrap: "" } },
                                    [
                                      _c(
                                        "v-flex",
                                        {
                                          staticClass: "save_in_app_creation",
                                          attrs: { xs12: "" }
                                        },
                                        [
                                          _c("v-spacer"),
                                          _vm._v(" "),
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass: "ma-3",
                                              attrs: {
                                                depressed: "",
                                                color: "grey lighten-3",
                                                id: "additionalfieldsBtn"
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.showAdditionalFields = !_vm.showAdditionalFields
                                                }
                                              }
                                            },
                                            [
                                              !_vm.showAdditionalFields
                                                ? _c("span", [
                                                    _vm._v("Additional Fields")
                                                  ])
                                                : _c("span", [_vm._v("Back")])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass: "ma-3",
                                              class: _vm.disableActionBtn
                                                ? "disabled"
                                                : "",
                                              attrs: {
                                                depressed: "",
                                                color: "grey lighten-3"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.getIdpSSOConfigEnteredFormData()
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                             Save\n                                         "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass: "ma-3",
                                              attrs: {
                                                depressed: "",
                                                color: "grey lighten-3"
                                              },
                                              on: { click: _vm.cancelEditSSO }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                             Cancel\n                                         "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ])
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "section",
                [
                  _c(
                    "v-dialog",
                    {
                      staticClass: "show-info-popup",
                      attrs: { width: "60rem", persistent: "" },
                      model: {
                        value: _vm.showTenantCreationPopup,
                        callback: function($$v) {
                          _vm.showTenantCreationPopup = $$v
                        },
                        expression: "showTenantCreationPopup"
                      }
                    },
                    [
                      _c("v-card", { staticClass: "popup-card" }, [
                        _c("div", { staticClass: "user_creation_popup_div" }, [
                          _c(
                            "div",
                            [
                              _c(
                                "v-form",
                                { ref: "form" },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "", wrap: "" } },
                                    [
                                      _c(
                                        "v-flex",
                                        {
                                          staticClass: "pa-2 ma-2",
                                          attrs: { xs1: "" }
                                        },
                                        [
                                          _vm.newcmpny.logo
                                            ? _c("span", [
                                                _c("img", {
                                                  staticClass: "logo-img",
                                                  attrs: {
                                                    src: _vm.newcmpny.logo,
                                                    id: "profile-img-tag"
                                                  }
                                                })
                                              ])
                                            : _c(
                                                "v-icon",
                                                {
                                                  staticClass:
                                                    "apps_creation_logo"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                 business\n                                             "
                                                  )
                                                ]
                                              )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        {
                                          staticClass: "pa-1 ma-2 mt-4 pt-3",
                                          attrs: { xs10: "" }
                                        },
                                        [_c("h3", [_vm._v("Tenant")])]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  !_vm.showAdditionalFields
                                    ? _c(
                                        "div",
                                        [
                                          _c(
                                            "v-layout",
                                            { attrs: { row: "", wrap: "" } },
                                            [
                                              _c(
                                                "v-flex",
                                                {
                                                  staticClass: "pa-2 ma-2 pt-3",
                                                  attrs: { xs3: "" }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                 Tenant name *\n                                             "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-flex",
                                                { attrs: { xs8: "" } },
                                                [
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      placeholder: "Tenant name"
                                                    },
                                                    model: {
                                                      value: _vm.newcmpny.name,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.newcmpny,
                                                          "name",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "newcmpny.name"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-layout",
                                            { attrs: { row: "", wrap: "" } },
                                            [
                                              _c(
                                                "v-flex",
                                                {
                                                  staticClass: "pa-2 ma-2 pt-4",
                                                  attrs: { xs3: "" }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                 Domain/Account ID *\n                                             "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-flex",
                                                {
                                                  staticClass: "pa-2",
                                                  attrs: { xs8: "" }
                                                },
                                                [
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      placeholder:
                                                        "Domain/Account ID",
                                                      rules:
                                                        _vm.domainValidation
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.newcmpny.domain,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.newcmpny,
                                                          "domain",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "newcmpny.domain"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-layout",
                                            { attrs: { row: "", wrap: "" } },
                                            [
                                              _c(
                                                "v-flex",
                                                {
                                                  staticClass: "pa-2 ma-2 pt-4",
                                                  attrs: { xs3: "" }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                 Whitelist Domains *\n                                             "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-flex",
                                                {
                                                  staticClass: "pa-2",
                                                  attrs: { xs8: "" }
                                                },
                                                [
                                                  _c("v-combobox", {
                                                    attrs: {
                                                      label:
                                                        "Whitelist Domains",
                                                      hint:
                                                        "Press Enter to add Domains",
                                                      multiple: "",
                                                      chips: "",
                                                      "deletable-chips": "",
                                                      "error-messages":
                                                        _vm.whitelistedDomainsValidate
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.newcmpny
                                                          .whitelist_domains,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.newcmpny,
                                                          "whitelist_domains",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "newcmpny.whitelist_domains"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-layout",
                                            { attrs: { row: "", wrap: "" } },
                                            [
                                              _c(
                                                "v-flex",
                                                {
                                                  staticClass: "pa-2 ma-2 pt-4",
                                                  attrs: { xs3: "" }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                 Type\n                                             "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-flex",
                                                {
                                                  staticClass: "pa-2",
                                                  attrs: { xs8: "" }
                                                },
                                                [
                                                  _c("v-select", {
                                                    attrs: {
                                                      items: _vm.tenantTypes,
                                                      "item-value": "field",
                                                      "item-text": "displayName"
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        _vm.setDefaultServer(
                                                          _vm.newcmpny
                                                        )
                                                        _vm.tenantAgreement =
                                                          "none"
                                                      }
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.newcmpny
                                                          .tenant_type,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.newcmpny,
                                                          "tenant_type",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "newcmpny.tenant_type"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _vm.newcmpny.tenant_type === "dome" ||
                                          _vm.newcmpny.tenant_type ===
                                            "analyzer"
                                            ? _c(
                                                "v-layout",
                                                {
                                                  attrs: { row: "", wrap: "" }
                                                },
                                                [
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      staticClass:
                                                        "pa-2 ma-2 pt-4",
                                                      attrs: { xs3: "" }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                 Servers\n                                             "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      staticClass: "px-2",
                                                      attrs: { xs8: "" }
                                                    },
                                                    [
                                                      _vm.newcmpny
                                                        .tenant_type === "dome"
                                                        ? _c("v-select", {
                                                            attrs: {
                                                              id: "tenantApps",
                                                              items:
                                                                _vm.domeServersList,
                                                              "item-value":
                                                                "key",
                                                              "item-text":
                                                                "display_name",
                                                              label:
                                                                "Dome servers",
                                                              chips: ""
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key:
                                                                    "selection",
                                                                  fn: function(
                                                                    ref
                                                                  ) {
                                                                    var item =
                                                                      ref.item
                                                                    return [
                                                                      _c(
                                                                        "v-chip",
                                                                        [
                                                                          _c(
                                                                            "span",
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  item.display_name
                                                                                )
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  }
                                                                }
                                                              ],
                                                              null,
                                                              false,
                                                              3458465267
                                                            ),
                                                            model: {
                                                              value:
                                                                _vm.newcmpny
                                                                  .dome_tenant_server,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.newcmpny,
                                                                  "dome_tenant_server",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "newcmpny.dome_tenant_server"
                                                            }
                                                          })
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _vm.newcmpny
                                                        .tenant_type ===
                                                      "analyzer"
                                                        ? _c("v-select", {
                                                            attrs: {
                                                              id: "tenantApps",
                                                              items:
                                                                _vm.analyzerServersList,
                                                              "item-value":
                                                                "key",
                                                              "item-text":
                                                                "display_name",
                                                              label:
                                                                "Analyzer servers",
                                                              chips: ""
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key:
                                                                    "selection",
                                                                  fn: function(
                                                                    ref
                                                                  ) {
                                                                    var item =
                                                                      ref.item
                                                                    return [
                                                                      _c(
                                                                        "v-chip",
                                                                        [
                                                                          _c(
                                                                            "span",
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  item.display_name
                                                                                )
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  }
                                                                }
                                                              ],
                                                              null,
                                                              false,
                                                              3458465267
                                                            ),
                                                            model: {
                                                              value:
                                                                _vm.newcmpny
                                                                  .analyzer_tenant_server,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.newcmpny,
                                                                  "analyzer_tenant_server",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "newcmpny.analyzer_tenant_server"
                                                            }
                                                          })
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "v-layout",
                                            { attrs: { row: "", wrap: "" } },
                                            [
                                              _c(
                                                "v-flex",
                                                {
                                                  staticClass: "pa-2 ma-2 pt-4",
                                                  attrs: { xs3: "" }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                 Agreements\n                                             "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-flex",
                                                {
                                                  staticClass: "pb-2",
                                                  attrs: { xs8: "" }
                                                },
                                                [
                                                  _c(
                                                    "v-radio-group",
                                                    {
                                                      attrs: { row: "" },
                                                      model: {
                                                        value:
                                                          _vm.tenantAgreement,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.tenantAgreement = $$v
                                                        },
                                                        expression:
                                                          "tenantAgreement"
                                                      }
                                                    },
                                                    [
                                                      _c("v-radio", {
                                                        class: _vm.configuredEula
                                                          ? ""
                                                          : "disabled",
                                                        attrs: {
                                                          label: "EULA",
                                                          value: "eula"
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("v-radio", {
                                                        class: _vm.configuredEvaluation
                                                          ? ""
                                                          : "disabled",
                                                        attrs: {
                                                          label: "EVALUATION",
                                                          value: "evaluation"
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("v-radio", {
                                                        attrs: {
                                                          label: "NONE",
                                                          value: "none"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _vm.tenantAgreement != "none"
                                            ? _c(
                                                "v-layout",
                                                {
                                                  attrs: { row: "", wrap: "" }
                                                },
                                                [
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      staticClass:
                                                        "pa-2 ma-2 pt-4",
                                                      attrs: { xs3: "" }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                 " +
                                                          _vm._s(
                                                            _vm.validateEditTenant
                                                              ? "Agreement Admins *"
                                                              : "Agreement Admins"
                                                          ) +
                                                          "\n                                             "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      staticClass: "px-2",
                                                      attrs: { xs8: "" }
                                                    },
                                                    [
                                                      _c("v-select", {
                                                        attrs: {
                                                          "hide-details": "",
                                                          items:
                                                            _vm.newcmpny
                                                              .users_list,
                                                          multiple: "",
                                                          chips: ""
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.newcmpny
                                                              .end_users,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.newcmpny,
                                                              "end_users",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "newcmpny.end_users"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "v-layout",
                                            { attrs: { row: "", wrap: "" } },
                                            [
                                              _c(
                                                "v-flex",
                                                {
                                                  staticClass: "pa-2 ma-2 pt-4",
                                                  attrs: { xs3: "" }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                 Password History\n                                             "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-flex",
                                                {
                                                  staticClass: "pa-2",
                                                  attrs: { xs8: "" }
                                                },
                                                [
                                                  _c(
                                                    "v-layout",
                                                    {
                                                      attrs: {
                                                        row: "",
                                                        wrap: ""
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-flex",
                                                        {
                                                          staticClass: "pl-1",
                                                          attrs: { xs4: "" }
                                                        },
                                                        [
                                                          _c("v-checkbox", {
                                                            attrs: {
                                                              label: "Enable",
                                                              id:
                                                                "enablepasswordhistory",
                                                              "hide-details": ""
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.newcmpny
                                                                  .password_history,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.newcmpny,
                                                                  "password_history",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "newcmpny.password_history"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.newcmpny
                                                        .password_history
                                                        ? _c(
                                                            "v-flex",
                                                            {
                                                              staticClass:
                                                                "pt-4",
                                                              attrs: { xs2: "" }
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v("Count")
                                                              ])
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _vm.newcmpny
                                                        .password_history
                                                        ? _c(
                                                            "v-flex",
                                                            {
                                                              attrs: { xs6: "" }
                                                            },
                                                            [
                                                              _c("v-select", {
                                                                attrs: {
                                                                  "hide-details":
                                                                    "",
                                                                  items: [
                                                                    1,
                                                                    2,
                                                                    3,
                                                                    4,
                                                                    5,
                                                                    6,
                                                                    7,
                                                                    8,
                                                                    9,
                                                                    10
                                                                  ]
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm.newcmpny
                                                                      .password_history_number,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.newcmpny,
                                                                      "password_history_number",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "newcmpny.password_history_number"
                                                                }
                                                              })
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-layout",
                                            { attrs: { row: "", wrap: "" } },
                                            [
                                              _c(
                                                "v-flex",
                                                {
                                                  staticClass: "pa-2 ma-2 pt-4",
                                                  attrs: { xs3: "" }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                 Password Expiration\n                                             "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-flex",
                                                {
                                                  staticClass: "pa-2",
                                                  attrs: { xs8: "" }
                                                },
                                                [
                                                  _c(
                                                    "v-layout",
                                                    {
                                                      attrs: {
                                                        row: "",
                                                        wrap: ""
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-flex",
                                                        {
                                                          staticClass: "pl-1",
                                                          attrs: { xs4: "" }
                                                        },
                                                        [
                                                          _c("v-checkbox", {
                                                            attrs: {
                                                              label: "Enable",
                                                              id:
                                                                "passwordExpiration",
                                                              "hide-details": ""
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.newcmpny
                                                                  .password_expiration,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.newcmpny,
                                                                  "password_expiration",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "newcmpny.password_expiration"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.newcmpny
                                                        .password_expiration
                                                        ? _c(
                                                            "v-flex",
                                                            {
                                                              staticClass:
                                                                "pt-4",
                                                              attrs: { xs3: "" }
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v(
                                                                  "Expiration Days"
                                                                )
                                                              ])
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _vm.newcmpny
                                                        .password_expiration
                                                        ? _c(
                                                            "v-flex",
                                                            {
                                                              attrs: { xs5: "" }
                                                            },
                                                            [
                                                              _c(
                                                                "v-text-field",
                                                                {
                                                                  attrs: {
                                                                    placeholder:
                                                                      "Days",
                                                                    type:
                                                                      "number"
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .newcmpny
                                                                        .password_expiration_days,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.newcmpny,
                                                                        "password_expiration_days",
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "newcmpny.password_expiration_days"
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-layout",
                                            { attrs: { row: "", wrap: "" } },
                                            [
                                              _c(
                                                "v-flex",
                                                {
                                                  staticClass: "pa-2 ma-2 pt-4",
                                                  attrs: { xs3: "" }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                 Apps Label\n                                             "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-flex",
                                                {
                                                  staticClass: "pa-2",
                                                  attrs: { xs8: "" }
                                                },
                                                [
                                                  _c("v-select", {
                                                    attrs: {
                                                      placeholder: "Apps Label",
                                                      items: _vm.appLabels
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.newcmpny.app_label,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.newcmpny,
                                                          "app_label",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "newcmpny.app_label"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _vm.appTypesData.length > 0
                                            ? _c(
                                                "v-layout",
                                                {
                                                  attrs: { row: "", wrap: "" }
                                                },
                                                [
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      staticClass:
                                                        "pa-2 ma-2 pt-4",
                                                      attrs: { xs3: "" }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                 Apps\n                                             "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      staticClass: "pa-2",
                                                      attrs: { xs8: "" }
                                                    },
                                                    [
                                                      _c("v-select", {
                                                        attrs: {
                                                          id: "tenantApps",
                                                          items:
                                                            _vm.appTypesData,
                                                          "item-value": "name",
                                                          "item-text":
                                                            "display_name",
                                                          label: "Apps",
                                                          multiple: "",
                                                          chips: ""
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "selection",
                                                              fn: function(
                                                                ref
                                                              ) {
                                                                var item =
                                                                  ref.item
                                                                return [
                                                                  _c("v-chip", [
                                                                    _c("span", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          item.display_name
                                                                        )
                                                                      )
                                                                    ])
                                                                  ])
                                                                ]
                                                              }
                                                            }
                                                          ],
                                                          null,
                                                          false,
                                                          3458465267
                                                        ),
                                                        model: {
                                                          value:
                                                            _vm.newcmpny
                                                              .selected_apps,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.newcmpny,
                                                              "selected_apps",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "newcmpny.selected_apps"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    : _c(
                                        "div",
                                        [
                                          _c(
                                            "v-layout",
                                            { attrs: { row: "", wrap: "" } },
                                            [
                                              _c(
                                                "v-flex",
                                                {
                                                  staticClass: "pa-2 ma-2 pt-4",
                                                  attrs: { xs3: "" }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                 Support Ticket\n                                             "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-flex",
                                                {
                                                  staticClass: "pa-2",
                                                  attrs: { xs8: "" }
                                                },
                                                [
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      placeholder:
                                                        "Support Ticket",
                                                      "error-messages": _vm.supportTicketValidate
                                                        ? ""
                                                        : "Not a valid URL or URL did not starts with http or https"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.newcmpny
                                                          .ticket_link,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.newcmpny,
                                                          "ticket_link",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "newcmpny.ticket_link"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-layout",
                                            { attrs: { row: "", wrap: "" } },
                                            [
                                              _c(
                                                "v-flex",
                                                {
                                                  staticClass: "pa-2 ma-2 pt-4",
                                                  attrs: { xs3: "" }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                 Sales Rep\n                                             "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-flex",
                                                {
                                                  staticClass: "pa-2",
                                                  attrs: { xs8: "" }
                                                },
                                                [
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      placeholder: "Sales Rep"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.newcmpny.sales_rep,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.newcmpny,
                                                          "sales_rep",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "newcmpny.sales_rep"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-layout",
                                            { attrs: { row: "", wrap: "" } },
                                            [
                                              _c(
                                                "v-flex",
                                                {
                                                  staticClass: "pa-2 ma-2 pt-4",
                                                  attrs: { xs3: "" }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                 Website\n                                             "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-flex",
                                                {
                                                  staticClass: "pa-2",
                                                  attrs: { xs8: "" }
                                                },
                                                [
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      name: "url",
                                                      id: "url",
                                                      placeholder: "website"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.newcmpny.website,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.newcmpny,
                                                          "website",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "newcmpny.website"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-layout",
                                            { attrs: { row: "", wrap: "" } },
                                            [
                                              _c(
                                                "v-flex",
                                                {
                                                  staticClass: "pa-2 ma-2 pt-4",
                                                  attrs: { xs3: "" }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                 Confluence\n                                             "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-flex",
                                                {
                                                  staticClass: "pa-2",
                                                  attrs: { xs8: "" }
                                                },
                                                [
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      placeholder: "Confluence",
                                                      "error-messages": _vm.confluenceValidate
                                                        ? ""
                                                        : "Not a valid URL or URL did not starts with http or https"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.newcmpny.confluence,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.newcmpny,
                                                          "confluence",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "newcmpny.confluence"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-layout",
                                            { attrs: { row: "", wrap: "" } },
                                            [
                                              _c(
                                                "v-flex",
                                                {
                                                  staticClass:
                                                    "pa-2 ma-2 pt-4 ",
                                                  attrs: { xs3: "" }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                 Drive location\n                                             "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-flex",
                                                {
                                                  staticClass: "pa-2",
                                                  attrs: { xs8: "" }
                                                },
                                                [
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      placeholder:
                                                        "Drive location",
                                                      "error-messages": _vm.driveLocationValidate
                                                        ? ""
                                                        : "Not a valid URL or URL did not starts with http or https"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.newcmpny
                                                          .drive_location,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.newcmpny,
                                                          "drive_location",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "newcmpny.drive_location"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                  _vm._v(" "),
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "", wrap: "" } },
                                    [
                                      _c(
                                        "v-flex",
                                        {
                                          staticClass: "save_in_app_creation",
                                          attrs: { xs12: "" }
                                        },
                                        [
                                          _c("v-spacer"),
                                          _vm._v(" "),
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass: "ma-3",
                                              attrs: {
                                                depressed: "",
                                                color: "grey lighten-3",
                                                id: "additionalfieldsBtn"
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.showAdditionalFields = !_vm.showAdditionalFields
                                                }
                                              }
                                            },
                                            [
                                              !_vm.showAdditionalFields
                                                ? _c("span", [
                                                    _vm._v("Additional Fields")
                                                  ])
                                                : _c("span", [_vm._v("Back")])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              class: _vm.disableActionBtn
                                                ? "disabled"
                                                : ""
                                            },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass: "ma-3",
                                                  class: _vm.saveButtonValidate
                                                    ? ""
                                                    : "disabled",
                                                  attrs: {
                                                    depressed: "",
                                                    color: "grey lighten-3",
                                                    id: "addTenantBtn",
                                                    tabindex: "-1"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.addNewTenant(
                                                        _vm.newcmpny
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                 save\n                                             "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass: "ma-3",
                                              attrs: {
                                                depressed: "",
                                                color: "grey lighten-3",
                                                id: "cancelEditBtn"
                                              },
                                              on: { click: _vm.cancelEdit }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                                 cancel\n                                             "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ])
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.deleteTenantPopUp
                ? _c("confirmationPopupVue", {
                    attrs: {
                      confirmationTitle: "Delete Tenant",
                      name: _vm.tenantInfo.name,
                      confirmationText: "delete tenant"
                    },
                    on: {
                      action: function($event) {
                        return _vm.deleteTenant()
                      },
                      close: function($event) {
                        return _vm.closeConfirmationPopUP()
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.notesPopup
                ? _c("NotesComponent", {
                    attrs: { notesInfo: _vm.notesInfo },
                    on: {
                      close: function($event) {
                        return _vm.closeNotes()
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }